import api from '../api/auth';

const ContactService = ({ email, title, details }) => {

    return api.post('/ask', { email, title, details });
};

export default ContactService;